import SectionHeading from "@/components/base/SectionHeading";
import { siteInfo, testimonials } from "@/mocks/comicData";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "忠于原作",
    text: "所有角色设定与关系梳理均以连载内容为据，不凭空编造剧情。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "讲清关系",
    text: "聚焦人物立场与互动逻辑，把复杂的人物关系讲得清清楚楚。",
  },
  {
    icon: "ri-flag-2-line",
    title: "积极向上",
    text: "延续故事温暖治愈的基调，传递家庭与相互理解的正面力量。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    text: "随连载进度同步补充新角色与关系线，保持内容新鲜准确。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-2 md:gap-10">
          <div className="flex flex-col gap-5">
            <SectionHeading
              align="left"
              eyebrow="关于本站"
              title="做一部温情漫画的角色指南"
              description={siteInfo.intro}
            />
            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              本站专注一件事：把《继母与继姐》里的人物关系与角色设定整理得明白易读。无论你是想快速认人、理清继母与继姐的立场，还是想回看某段关系的起点，这里都是你的第一站。
            </p>
            <div className="flex flex-wrap gap-2">
              {["角色设定", "人物关系", "主角介绍", "剧情看点", "关系梳理"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl border border-background-200/80 bg-background-100 p-5"
              >
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14">
          <h3 className="text-center font-heading text-lg md:text-xl font-bold text-foreground-900">
            读者口碑
          </h3>
          <div className="mt-6 grid gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col gap-3 rounded-2xl border border-background-200/80 bg-background-100 p-6"
              >
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-foreground-700">
                  「{t.content}」
                </blockquote>
                <figcaption className="mt-auto text-xs font-medium text-foreground-500">
                  — {t.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}